<ng-container *ngIf="!nzInline; else inlineMode">
  <!-- Content of single picker -->
  <div *ngIf="!isRange" class="{{ prefixCls }}-input">
    <input
      #pickerInput
      [attr.id]="nzId"
      [class.ant-input-disabled]="nzDisabled"
      [disabled]="nzDisabled"
      [readOnly]="nzInputReadOnly"
      [(ngModel)]="inputValue"
      placeholder="{{ getPlaceholder() }}"
      [size]="inputSize"
      autocomplete="off"
      (focus)="onFocus($event)"
      (focusout)="onFocusout($event)"
      (ngModelChange)="onInputChange($event)"
      (keyup.enter)="onKeyupEnter($event)" />
    <ng-container *ngTemplateOutlet="tplRightRest"></ng-container>
  </div>

  <!-- Content of range picker -->
  <ng-container *ngIf="isRange">
    <div class="{{ prefixCls }}-input">
      <ng-container *ngTemplateOutlet="tplRangeInput; context: { partType: 'left' }"></ng-container>
    </div>
    <div #separatorElement class="{{ prefixCls }}-range-separator">
      <span class="{{ prefixCls }}-separator">
        <ng-container *ngIf="nzSeparator; else defaultSeparator">{{ nzSeparator }}</ng-container>
      </span>
      <ng-template #defaultSeparator>
        <ui-icon uiType="swap-right" uiTheme="outline"></ui-icon>
      </ng-template>
    </div>
    <div class="{{ prefixCls }}-input">
      <ng-container *ngTemplateOutlet="tplRangeInput; context: { partType: 'right' }"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="tplRightRest"></ng-container>
  </ng-container>
</ng-container>
<!-- Input for Range ONLY -->
<ng-template #tplRangeInput let-partType="partType">
  <input
    #rangePickerInput
    [attr.id]="nzId"
    [disabled]="nzDisabled"
    [readOnly]="nzInputReadOnly"
    [size]="inputSize"
    autocomplete="off"
    (click)="onClickInputBox($event)"
    (focusout)="onFocusout($event)"
    (focus)="onFocus($event, partType)"
    (keyup.enter)="onKeyupEnter($event)"
    [(ngModel)]="inputValue[datePickerService.getActiveIndex(partType)]"
    (ngModelChange)="onInputChange($event)"
    placeholder="{{ getPlaceholder(partType) }}" />
</ng-template>

<!-- Right operator icons -->
<ng-template #tplRightRest>
  <div class="{{ prefixCls }}-active-bar" [ngStyle]="activeBarStyle"></div>
  <span *ngIf="showClear()" class="{{ prefixCls }}-clear" (click)="onClickClear($event)">
    <ui-icon uiType="close-circle" uiTheme="outline"></ui-icon>
  </span>
  <span class="{{ prefixCls }}-suffix">
    <ng-container *nzStringTemplateOutlet="nzSuffixIcon; let suffixIcon">
      <ui-icon [uiType]="suffixIcon"></ui-icon>
    </ng-container>
  </span>
</ng-template>

<ng-template #inlineMode>
  <div
    class="{{ prefixCls }}-dropdown {{ nzDropdownClassName }}"
    [class.ant-picker-dropdown-rtl]="dir === 'rtl'"
    [class.ant-picker-dropdown-placement-bottomLeft]="currentPositionY === 'bottom' && currentPositionX === 'start'"
    [class.ant-picker-dropdown-placement-topLeft]="currentPositionY === 'top' && currentPositionX === 'start'"
    [class.ant-picker-dropdown-placement-bottomRight]="currentPositionY === 'bottom' && currentPositionX === 'end'"
    [class.ant-picker-dropdown-placement-topRight]="currentPositionY === 'top' && currentPositionX === 'end'"
    [class.ant-picker-dropdown-range]="isRange"
    [class.ant-picker-active-left]="datePickerService.activeInput === 'left'"
    [class.ant-picker-active-right]="datePickerService.activeInput === 'right'"
    [ngStyle]="nzPopupStyle">
    <ui-date-range-popup
      [uiIsRange]="isRange"
      [uiInline]="nzInline"
      [uiDefaultPickerValue]="nzDefaultPickerValue"
      [uiShowWeek]="nzMode === 'week'"
      [uiPanelMode]="panelMode"
      (uiPanelModeChange)="onPanelModeChange($event)"
      (uiCalendarChange)="onCalendarChange($event)"
      [uiLocale]="nzLocale?.lang!"
      [uiShowToday]="nzMode === 'date' && nzShowToday && !isRange && !nzShowTime"
      [uiShowNow]="nzMode === 'date' && nzShowNow && !isRange && !!nzShowTime"
      [uiShowTime]="nzShowTime"
      [uiDateRender]="nzDateRender"
      [uiDisabledDate]="nzDisabledDate"
      [uiDisabledTime]="nzDisabledTime"
      [uiExtraFooter]="extraFooter"
      [uiRanges]="nzRanges"
      [uiDir]="dir"
      (uiResultOk)="onResultOk()"></ui-date-range-popup>
  </div>
</ng-template>

<!-- Overlay -->
<ng-template
  cdkConnectedOverlay
  nzConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="nzBackdrop"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="realOpenState"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayTransformOriginOn]="'.ant-picker-wrapper'"
  (positionChange)="onPositionChange($event)"
  (detach)="close()"
  (overlayKeydown)="onOverlayKeydown($event)">
  <div class="ant-picker-wrapper" style="position: relative">
    <ng-container *ngTemplateOutlet="inlineMode"></ng-container>
  </div>
</ng-template>
